<template>
  <div class="student-turn d-flex justify-content-end">
    <div class="msg_container" :class="{ 'loading': isLoading }">
      <div v-if="isLoading">
        <MessageLoading :phase="phase" />
      </div>
      <div v-else>
        {{ msg }}
        <AudioPlayer v-if="audioId" :audioId="audioId" :isAutoPlay="autoPlay" />
      </div>
    </div>
  </div>
</template>

<script>
import MessageLoading from "./MessageLoading.vue";
import AudioPlayer from "./AudioPlayer.vue";

export default {
  name: "StudentMessage",
  props: {
    msg: String,
    audioId: String,
    isLoading: { type: Boolean, default: false },
    phase: { type: String, default: "thinking" },
    autoPlay: { type: Boolean, default: false },
  },
  components: {
    AudioPlayer,
    MessageLoading,
  },
};
</script>

<style scoped>
.student-turn {
  margin-bottom: 24px;
}

@media (prefers-reduced-motion: no-preference) {
  .student-turn {
    animation: msg-enter var(--al-dur-short) var(--al-ease-enter);
  }
}

@keyframes msg-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}

/* DECISION D-B: keep the warm student bubble. Text uses the --al-text role:
   ink-900 on the light warm bubble (~10:1) and near-white on the dark
   warm-tinted bubble, both comfortably above the 4.5:1 AA bar. The bubble
   itself (vs. Arti's open-canvas text) is what distinguishes the speakers,
   so no avatar is needed. */
.msg_container {
  border-radius: 18px 18px 6px 18px;
  background-color: var(--al-warm-soft);
  color: var(--al-text);
  padding: 11px 15px;
  position: relative;
  max-width: 82%;
  width: auto;
  text-align: left;
  font-size: 15px;
  line-height: 1.55;
  box-shadow: 0 1px 2px rgba(8, 26, 49, 0.05);
}

.msg_container.loading {
  min-width: auto;
  width: fit-content;
}

/* The audio pill drops to its own line under the transcript (inline-flex
   would park it beside the text and stretch the bubble). */
.msg_container :deep(.chat-audio) {
  display: flex;
  width: fit-content;
}

@media (max-width: 768px) {
  .msg_container {
    max-width: 88%;
  }

  .msg_container.loading {
    width: fit-content;
  }
}
</style>
